import React, {useEffect} from "react";
import {useField} from "react-final-form";

interface WhenFieldsDataHandlerInterface {
    when: string;
    setWhenConditionObject: React.Dispatch<
        React.SetStateAction<{
            [key: string]: string | Record<string, unknown>;
        }>
    >;
}

const WhenFieldsDataHandler: React.FC<WhenFieldsDataHandlerInterface> = ({
    when,
    setWhenConditionObject,
}: WhenFieldsDataHandlerInterface) => {
    const {input} = useField<Record<string, unknown> | string>(when, {
        subscription: {value: true},
    });
    const value = input.value;

    useEffect(() => {
        const obj: {[key: string]: Record<string, unknown> | string} = {};
        obj[when] = value;
        setWhenConditionObject((prev) => {
            return {...prev, ...obj};
        });
    }, [value, setWhenConditionObject, when]);
    return null;
};

interface WhenCondition {
    whenFields: string[];
    setWhenConditionObject: React.Dispatch<
        React.SetStateAction<{
            [key: string]: string | Record<string, unknown>;
        }>
    >;
}
const WhenCondition: React.FC<WhenCondition> = ({
    whenFields,
    setWhenConditionObject,
}: WhenCondition) => {
    return (
        <>
            {whenFields.map((val, index) => {
                return (
                    <WhenFieldsDataHandler
                        when={val}
                        setWhenConditionObject={setWhenConditionObject}
                        key={`${index}`}
                    />
                );
            })}
        </>
    );
};

export default WhenCondition;
